'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (value, params) {
    return value === '' || value === null || value === undefined;
};